import {IKeyWordFiltrationEnabledSetAction} from './types';
import {AT_KEY_WORD_FILTRATION_ENABLED_SET} from './constants';

export const keywordFiltrationEnabledSet = (
    isKeywordFiltrationEnabled: boolean
): IKeyWordFiltrationEnabledSetAction => ({
    type: AT_KEY_WORD_FILTRATION_ENABLED_SET,
    isKeywordFiltrationEnabled
});
